<template>
  <transition name="fade">
    <div v-if="visible" class="fixed" @click.stop>
      <div class="bg-white popup">
        <div class="popup-header">
          <h1 class="title">Añadir categoría secundaria</h1>
          <img src="@/assets/images/ic_close.svg" class="close_icon" @click="closePopup()" />
        </div>
        
        <div class="popup-body">
          <div class="form-row">
            <div class="fields">
              <div class="input-50">
                <label>Categoría*</label>
                <select v-model="currentCategory.categoria">
                  <option value="bienestar">Bienestar</option>
                  <option value="deportes">Deportes</option>
                  <option value="gastro">Gastro</option>
                  <option value="ocio">Ocio</option>
                  <option value="viajes">Viajes</option>
                  <option value="regalos">Regalos</option>
                </select>
              </div>
              <div class="input-50">
                <label>Subcategoría*</label>
                <select v-model="currentCategory.subcategoria">
                  <option v-if="currentCategory.categoria == 'bienestar'" value="dentista">Dentista</option>
                  <option v-if="currentCategory.categoria == 'bienestar'" value="estetica">Estética</option>
                  <option v-if="currentCategory.categoria == 'bienestar'" value="masajes-fisioterapia">Masajes y fisioterapia</option>
                  <option v-if="currentCategory.categoria == 'bienestar'" value="medicina">Medicina</option>
                  <option v-if="currentCategory.categoria == 'bienestar'" value="mindfulness-relax">Mindfulness</option>
                  <option v-if="currentCategory.categoria == 'bienestar'" value="nutricionista">Nutrición</option>
                  <option v-if="currentCategory.categoria == 'bienestar'" value="peluqueria">Peluquería</option>
                  <option v-if="currentCategory.categoria == 'bienestar'" value="psicologia">Psicología</option>
                  <option v-if="currentCategory.categoria == 'bienestar'" value="spa-balneario">Spas y balnearios</option>
                  <option v-if="currentCategory.categoria == 'bienestar'" value="tattoos">Tattoos</option>
                  <option v-if="currentCategory.categoria == 'deportes'" value="clases-de-baile">Clases de Baile</option>
                  <option v-if="currentCategory.categoria == 'deportes'" value="natacion-aquagym-piscina">Deportes acuáticos</option>
                  <option v-if="currentCategory.categoria == 'deportes'" value="deportes-de-equipo">Deportes de equipo</option>
                  <option v-if="currentCategory.categoria == 'deportes'" value="fitness-gym">Deportes de gym</option>
                  <option v-if="currentCategory.categoria == 'deportes'" value="esqui-raquetas-quad-buggy-deportes-invierno">Deportes de invierno</option>
                  <option v-if="currentCategory.categoria == 'deportes'" value="boxeo-taekwondo-lucha">Deportes de lucha</option>
                  <option v-if="currentCategory.categoria == 'deportes'" value="barranquismo-parapente-ferratas-montana">Deportes de montaña</option>
                  <option v-if="currentCategory.categoria == 'deportes'" value="karts-paratrike-motor">Deportes de motor</option>
                  <option v-if="currentCategory.categoria == 'deportes'" value="deportes-de-raqueta">Deportes de raqueta</option>
                  <option v-if="currentCategory.categoria == 'deportes'" value="deportes-individuales">Deportes individuales</option>
                  <option v-if="currentCategory.categoria == 'gastro'" value="asiatica">Asiática</option>
                  <option v-if="currentCategory.categoria == 'gastro'" value="cursos-talleres-catas">Cursos, talleres y catas</option>
                  <option v-if="currentCategory.categoria == 'gastro'" value="desayunos-dulces-brunch">Dulces, desayunos y brunch</option>
                  <option v-if="currentCategory.categoria == 'gastro'" value="americana">Hamburguesas y bocadillos</option>
                  <option v-if="currentCategory.categoria == 'gastro'" value="healthy">Healthy</option>
                  <option v-if="currentCategory.categoria == 'gastro'" value="internacional">Internacional</option>
                  <option v-if="currentCategory.categoria == 'gastro'" value="mediterranea">Mediterránea</option>
                  <option v-if="currentCategory.categoria == 'gastro'" value="italiana">Pizza y pasta</option>
                  <option v-if="currentCategory.categoria == 'gastro'" value="vegetariana-y-vegana">Vegetariana y vegana</option>
                  <option v-if="currentCategory.categoria == 'ocio'" value="cine-teatro">Cine y teatro</option>
                  <option v-if="currentCategory.categoria == 'ocio'" value="conocer-gente">Conocer gente</option>
                  <option v-if="currentCategory.categoria == 'ocio'" value="cursos-talleres-pintura-ceramica">Cursos y talleres</option>
                  <option v-if="currentCategory.categoria == 'ocio'" value="escape-room-ocio-alternativo">Escape room y ocio alternativo</option>
                  <option v-if="currentCategory.categoria == 'ocio'" value="fotografia">Fotografía</option>
                  <option v-if="currentCategory.categoria == 'ocio'" value="juegos-rol-mesa-videojuegos">Juegos de mesa y videojuegos</option>
                  <option v-if="currentCategory.categoria == 'ocio'" value="museos-exposiciones">Museos y exposiciones</option>
                  <option v-if="currentCategory.categoria == 'ocio'" value="nocturno-musica">Música y ocio nocturno</option>
                  <option v-if="currentCategory.categoria == 'ocio'" value="practicar-idiomas">Practicar idiomas</option>
                  <option v-if="currentCategory.categoria == 'viajes'" value="autocaravana">Autocaravana</option>
                  <option v-if="currentCategory.categoria == 'viajes'" value="camper">Camper</option>
                  <option v-if="currentCategory.categoria == 'viajes'" value="casas-rurales-hoteles">Casas rurales y hoteles</option>
                  <option v-if="currentCategory.categoria == 'viajes'" value="en-grupo">En grupo</option>
                  <option v-if="currentCategory.categoria == 'viajes'" value="en-pareja">En pareja</option>
                  <option v-if="currentCategory.categoria == 'viajes'" value="excursiones">Excursiones</option>
                  <option v-if="currentCategory.categoria == 'viajes'" value="playa-montana">Playa y montaña</option>
                  <option v-if="currentCategory.categoria == 'regalos'" value="tarjetas-regalo">Tarjetas de regalo</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="popup-footer">
          <button @click="closePopup()" class="secondary_button">Cancelar</button>
          <button @click="saveClicked()" class="main_button">Guardar</button>
        </div>
      </div>

    </div>
  </transition>
</template>

<script setup>
  import { ref, watch, defineProps, defineEmits } from 'vue';

  const props = defineProps({
    category: Object,
  });
  
  const emit = defineEmits(['categoryChanged', 'categoryPopupCancelled', 'categoryErrorHappened']);

  const visible = ref(false);
  const currentCategory = ref(null);

  watch(() => props.category, (newVal) => {
    currentCategory.value = newVal;
    visible.value = !!newVal;
  });
  
  const closePopup = () => {
    visible.value = false;
    currentCategory.value = null;
    emit('categoryPopupCancelled');
  };

  const saveClicked = async () => {
    if (currentCategory.value.categoria.trim() === "" || currentCategory.value.subcategoria.trim() === "") {
      emit('categoryErrorHappened', 'Por favor, completa todos los campos obligatorios');
      return;
    }

    emit('categoryChanged', currentCategory.value);
    closePopup();
  }

  </script>
  
<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  
  .fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
  
  .bg-white {
    background-color: white;
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-lg);
    width: 100%;
    max-width: 800px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  
  .popup-header {
    padding: var(--spacing-md) var(--spacing-lg);
    border-bottom: 1px solid var(--light-gray);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .title {
    font-size: 20px;
    font-weight: 700;
    color: var(--text-color-dark);
    margin: 0;
  }

  .close_icon {
    position: absolute;
    right: var(--spacing-md);
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    cursor: pointer;
    opacity: 0.6;
    transition: opacity var(--transition-fast);
  }

  .close_icon:hover {
    opacity: 1;
  }

  .popup-body {
    padding: var(--spacing-lg);
    overflow-y: auto;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-md);
  }

  .form-row {
    display: flex;
    gap: var(--spacing-md);
  }

  .fields {
    display: flex;
    width: 100%;
    gap: var(--spacing-md);
  }

  .input-50 {
    flex: 1;
  }

  .input-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .input-group.half {
    flex: 1;
  }

  .input-group.third {
    flex: 1;
  }

  .input-group.full {
    width: 100%;
  }

  label {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-color-dark);
  }

  input, select {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    border: 1px solid var(--light-gray);
    border-radius: var(--radius-md);
    font-family: inherit;
    font-size: 14px;
    transition: border-color var(--transition-fast);
  }

  input:focus, select:focus {
    outline: none;
    border-color: var(--primary-color);
  }

  input:disabled, select:disabled {
    background-color: var(--almost-white);
    color: var(--text-color-placeholder);
  }

  .checkboxes {
    margin-top: var(--spacing-sm);
    justify-content: space-between;
  }

  .checkbox-group {
    flex: 1;
    display: flex;
    justify-content: center;
  }

  .checkbox-label {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-weight: normal;
  }

  .active_checkbox {
    width: 20px;
    margin: 0;
  }

  .popup-footer {
    padding: var(--spacing-md) var(--spacing-lg);
    border-top: 1px solid var(--light-gray);
    display: flex;
    justify-content: flex-end;
    gap: var(--spacing-md);
    background-color: var(--white);
  }

  .secondary_button, .main_button {
    width: auto;
    min-width: 120px;
  }

  @media (max-width: 768px) {
    .form-row {
      flex-direction: column;
    }
    
    .checkboxes {
      flex-direction: row;
      flex-wrap: wrap;
    }

    .checkbox-group {
      justify-content: flex-start;
      width: 100%;
      margin-bottom: 10px;
    }
  }
  </style>
